import "./Footer.css";

const Footer = () => {

    return (
        <div className="footer">
            <div className="footer-bottom"/>
            <p>© 2025 Bernardo Tameirão. All rights reserved.</p>
        </div>
    );
}

export {Footer};